import { useGetMasterAccountSummaryQuery } from "../../../services/clientsearch/masterAccountApiEndpoints"
import { useClientContext } from "../../../hooks/ClientContext"

export const useGetClientSummaryDetails = () => {
    const { id: masterAccountId } = useClientContext();
    const { data, error, isLoading } = useGetMasterAccountSummaryQuery(masterAccountId);

    return {
        data, error, isLoading
    }
}